export { makePageContentService } from './pageContentService';

export type {
  PageContentService,
  PageAncestorContent,
} from './pageContentService';
